// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".loader-overlay[data-v-8fa4d1ac]{position:fixed;top:0;left:0;width:100%;height:100%;background:hsla(0,0%,100%,.8);display:flex;justify-content:center;align-items:center;z-index:9999}.loader[data-v-8fa4d1ac]{border:5px solid #f3f3f3;border-top:5px solid #005eeb;border-radius:50%;width:50px;height:50px;animation:spin-8fa4d1ac 1s linear infinite}@keyframes spin-8fa4d1ac{0%{transform:rotate(0deg)}to{transform:rotate(1turn)}}", ""]);
// Exports
module.exports = exports;
